import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { dateDiff } from '@wix/da-ds/pkg/Time/functions';
import { CommentContext } from '../../CommentContext';
export function useButtonConditionals({ canPostComment = true } = {}) {
    const { comment } = useContext(CommentContext);
    const { isLoggedIn } = useContext(SessionContext);
    const canEdit = comment.isAuthor && dateDiff(new Date().toISOString(), comment.posted, 'days') === 0;
    return {
        showEditButton: (canPostComment || !isLoggedIn) && canEdit,
        showReplyButton: canPostComment || !isLoggedIn,
        // TODO: Referring to the doc comment below, separate the like counter from the like button?
        /**
     * We always show the like button because the like counter is part of it at the moment
     */ showLikeButton: true,
        showAwardBadgeButton: !comment.isAuthor
    };
}
